import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Barcodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      count: 10,
      page: 1,

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      branch_name: "",
      account_name: "",
      is_default: "",
      is_active: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count;
    loading(true);
    let [result] = await Promise.all([GET("admin/setting/banks/list", { page: page, data_search: this.state.filter_search })]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      page,
      data,
      count,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, bank_name, account_number, branch_name, account_name, is_default, is_active } = this.state;
    if (!bank_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอก Name");
      return;
    } else if (!account_number.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอก Phone");
      return;
    }

    loading(true);
    let body = {
      bank_name,
      account_number,
      branch_name,
      account_name,
      is_default,
      is_active,
    };

    let result = !uid ? await POST("admin/setting/banks/create", body) : await PUT("admin/setting/banks/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
      loading(true);
      let result = await DELETE("admin/setting/banks/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const { page, modal_create, modal_update, filter_search, data, count, id, uid, bank_name, account_number, branch_name, account_name, is_default, is_active } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">บัญชีธนาคาร</h4>
              <button
                className="btn btn-dark px-3 ms-auto mb-2 banks.create"
                onClick={async () => {
                  this.setState({ id: "", uid: "", bank_name: "", account_number: "", branch_name: "", account_name: "", is_default: true, is_active: true, modal_create: true });
                }}
              >
                เพิ่มรายการ
              </button>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">ธนาคาร</td>
                    <td className="text-nowrap">เลขที่บัญชี</td>
                    <td className="text-nowrap">ชื่อบัญชี</td>
                    <td className="text-nowrap">สาขา</td>
                    <td className="text-nowrap">บัญชีหลัก</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{((page - 1)*10) + index + 1}</td>
                      <td className="text-nowrap">{global.bank.find((e) => e.value === item.bank_name)?.label || "-"}</td>
                      <td className="text-nowrap">{item.account_number || "-"}</td>
                      <td className="text-nowrap">{item.account_name || "-"}</td>
                      <td className="text-nowrap">{item.branch_name || "-"}</td>
                      <td className="text-nowrap">{item.is_default? (Status("บัญชีหลัก","success")):null}</td>
                      <td className="text-nowrap">{item.is_active? (Status("ใช้งาน","success")):(Status("ไม่ใช้งาน","danger"))}</td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="banks.update"
                            type="update"
                            onClick={() => {
                              this.setState({ ...item, modal_update: true });
                            }}
                          />
                          <BtnIcon
                            className="banks.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete(item.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">{modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}บัญชีธนาคาร</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ธนาคาร{required}</div>
              <Select
                className="form-control"
                placeholder="ธนาคาร..."
                options={global.bank}
                onChange={(e) => {
                  this.setState({ bank_name: e });
                }}
                value={bank_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">เลขที่บัญชี{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="เลขที่บัญชี..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ account_number: e.target.value });
                }}
                value={account_number}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อบัญชีธนาคาร</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อบัญชีธนาคาร..."
                onChange={(e) => {
                  this.setState({ account_name: e.target.value });
                }}
                value={account_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">สาขา</div>
              <input
                type="text"
                className="form-control"
                placeholder="สาขา..."
                onChange={(e) => {
                  this.setState({ branch_name: e.target.value });
                }}
                value={branch_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ตั้งเป็นบัญชีหลัก</div>
              <Switch
                onChange={(e) => {
                  this.setState({ is_default: e });
                }}
                checked={is_default}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ใช้งาน</div>
              <Switch
                onChange={(e) => {
                  this.setState({ is_active: e });
                }}
                checked={is_active}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
